import "./style.scss";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLocationDot } from "@fortawesome/pro-solid-svg-icons";
import { faCalendar } from "@fortawesome/pro-light-svg-icons";
import moment from "moment/moment";
import CalenderDateRangePicker from "../CalenderDatePicker/CalenderDateRangePicker";
import {
    getSearchFilters, setSelectedFavoriteHotel,
    setTravelDate,
    setTravelers,
} from "../../redux/slices/searchFilterSlice";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLoginConfig } from "../../redux/slices/loginconfigSlice";
import {
    setActivityIndicator,
} from "../../redux/slices/appconfigSlice";
import {
    navigateToDetailPage,
} from "../../helpers/common";
import { GetSearchOnlyForHotel } from "../../services/AppService";
import { toast } from "react-toastify";
import DepartureFromModal from "../Modals/DepartureFromModal";
import Travelers from "../sections/QuickFilters/Travelers";
import PropTypes from "prop-types";
import useTranslationCustom from "../../i18n/customHook/useTranslation";

// Parallel Web Link version of FavoriteAccordion. Same UI/styling/behavior, but
// consumes the FLAT decoded share data (see src/utils/webShareLink.js) instead of
// the nested Branch offer object. The Branch FavoriteAccordion is left untouched.
//
// Shared guard so the auto-search only fires once across the desktop + small
// cards that mount this at the same time.
let autoSearchedOfferId = null;

const FavoriteAccordionWebLink = ({ offer, isBranched = false }) => {
    const { T } = useTranslationCustom();
    const calendarTriggerRef = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const searchfilters = useSelector(getSearchFilters);
    const loginConfig = useSelector(getLoginConfig);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showTraveler, setShowTraveler] = useState(false);
    const [hasUserSelectedDates, setHasUserSelectedDates] = useState(false);
    const [departureFrom, setLocalDepartureFrom] = useState([]);
    const [modals, setModals] = useState({
        destination: false,
        departure: false,
    });

    // Flat share data carries the dates directly.
    const resolvedDepartureDate = offer?.departureDate;
    const resolvedReturnDate = offer?.returnDate;

    const [hotelPreviousFilters] = useState({
        travelers: searchfilters?.travelers,
        departureFrom: searchfilters?.departureFrom,
        dateRangeState: [
            {
                key: "selection",
                startDate: new Date(resolvedDepartureDate),
                endDate: new Date(resolvedReturnDate),
            },
        ],
    });
    const [tdetails, setTDetails] = useState('');

    useEffect(() => {
        // Flat data carries the origin airport code directly.
        setLocalDepartureFrom([offer?.departure]);

        const total =
            (Number(offer?.adults) || 0) + (Number(offer?.children) || 0) + (Number(offer?.infants) || 0);
        const rooms = Number(offer?.rooms) || 1;
        setTDetails(
            `${rooms} ${rooms > 1 ? T("Common:Rooms") : T("Common:Room")}, ${total} ${total <= 1 ? T("Common:Traveler").toLowerCase() : T("Common:Travelers").toLowerCase()}`
        );
    }, [])

    const getHotelDetailsAndNavigate = (e) => {
        e?.preventDefault?.();
        let searchParams = {
            GUID: "",
            Locale: loginConfig?.locale?.code,
            HotelId: offer?.hotelId,
            Page: 1,
            currency: loginConfig?.currency?.code,
        };

        let PassengerAgeRoomItemList = [];
        let roomcounter = 1;

        searchfilters.travelers.forEach((element) => {
            for (let i = 0; i < element.infants; i++) {
                PassengerAgeRoomItemList.push({
                    PassengerCategory: "Infant",
                    Room: roomcounter,
                });
            }
            for (let i = 0; i < element.adult; i++) {
                PassengerAgeRoomItemList.push({
                    PassengerCategory: "Adult",
                    Room: roomcounter,
                });
            }
            for (let i = 0; i < element.child; i++) {
                PassengerAgeRoomItemList.push({
                    PassengerCategory: "Child",
                    Room: roomcounter,
                });
            }
            roomcounter++;
        });

        let FlightSegmentList = [];
        if (departureFrom || searchfilters.departureFrom.length) {
            let inbound_params = {};
            let outbound_params = {};

            inbound_params.Departure = {
                CodeList: departureFrom,
                Date: moment(!hasUserSelectedDates && datesExistsAndValid() ? resolvedDepartureDate : (searchfilters.travelDate.startDate || new Date())).format("YYYY-MM-DD"),
            };

            // Flat data carries the destination airport code directly.
            inbound_params.Arrival = {
                CodeList: [offer?.destination],
            };

            outbound_params.Departure = {
                CodeList: [offer?.destination],
                Date: moment(!hasUserSelectedDates && datesExistsAndValid() ? resolvedReturnDate : (searchfilters.travelDate.endDate || new Date())).format("YYYY-MM-DD"),
            };

            outbound_params.Arrival = {
                IataCodeList: departureFrom,
            };

            FlightSegmentList.push(inbound_params);
            FlightSegmentList.push(outbound_params);

        } else {
            return toast.info(T("Toasts:Please_Choose_Departure"));
        }

        if (FlightSegmentList.length > 0) {
            searchParams["FlightSegmentList"] = FlightSegmentList;
        }

        if (PassengerAgeRoomItemList.length > 0) {
            searchParams["PassengerAgeRoomItemList"] = PassengerAgeRoomItemList;
        }

        dispatch(setActivityIndicator(true));
        GetSearchOnlyForHotel(searchParams)
            .then((response) => {
                dispatch(setActivityIndicator(false));

                if (response?.data?.warnings?.length) {
                    toast.warning(response?.data?.warnings[0]?.description);
                }

                let _offers = response?.data?.offers?.map((hotel) => {
                    if (hotel !== undefined) {
                        return {
                            ...hotel?.newPackagedOffer?.hotelOfferSingleRoom,
                            price: {
                                totalPrice: hotel?.price?.packageTotalPrice?.value,
                                currency: hotel?.price?.packageTotalPrice?.currency,
                            },
                            perPersonPrice: {
                                totalPrice: hotel?.price?.averageCostPerPerson?.value,
                                currency: hotel?.price?.averageCostPerPerson?.currency,
                            },
                            address:
                                hotel?.newPackagedOffer?.hotelOfferSingleRoom?.location?.address
                                    ?.city +
                                ", " +
                                hotel?.newPackagedOffer?.hotelOfferSingleRoom?.location?.address
                                    ?.country,
                            objHotel: hotel,
                            guidForBooking: response?.data?.correlationId,
                        };
                    }
                });

                dispatch(setSelectedFavoriteHotel(_offers[0]));

                if (_offers?.length) {
                    navigateToDetailPage(
                        _offers[0],
                        dispatch,
                        loginConfig,
                        searchfilters,
                        navigate,
                        "hotel",
                        null,
                        true,
                        false,
                        null, // Branch data null
                        offer?.flightNumbersString,
                    );
                }
            })
            .catch((e) => {
                console.error(e);
                dispatch(setActivityIndicator(false));
                revertValuesToPrevious();
            });
    };

    const revertValuesToPrevious = () => {
        dispatch(setTravelers(hotelPreviousFilters?.travelers));

        setLocalDepartureFrom([offer?.departure]);

        dispatch(setTravelDate({
            startDate: new Date(hotelPreviousFilters.dateRangeState[0].startDate).toDateString(),
            endDate: new Date(hotelPreviousFilters.dateRangeState[0].endDate).toDateString(),
        }));
    };

    const getDepartureFromText = () => {
        if (departureFrom?.length) {
            return departureFrom?.join(', ')
        } else {
            return searchfilters?.departureFrom.map(a => a.code)?.join(', ')
        }
    }

    const datesExistsAndValid = () => {
        if (!resolvedDepartureDate || !resolvedReturnDate) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const maxReturnDate = new Date(today);
        maxReturnDate.setDate(maxReturnDate.getDate() + 332);

        const departure = new Date(resolvedDepartureDate);
        const returnDate = new Date(resolvedReturnDate);

        if (departure < today) return false;
        if (departure > returnDate) return false;
        if (returnDate < today || returnDate > maxReturnDate) return false;

        return true;
    }

    // A Web Link is always a shared offer.
    const isBranchSharedOffer = true;

    // Mirrors every guard inside getHotelDetailsAndNavigate so the auto-search only
    // fires when that function would actually succeed (no toasts / early returns).
    const canAutoSearch = () => {
        // Gate on the local departureFrom only — that is the value actually sent as
        // CodeList/IataCodeList. It is populated asynchronously by the mount effect, so
        // checking the Redux fallback here would let the auto-search fire one render too
        // early (before departureFrom is set), producing an empty CodeList.
        const hasDeparture = Boolean(departureFrom?.filter(Boolean)?.length);
        const hasDestination = Boolean(offer?.destination);
        return hasDeparture && hasDestination && datesExistsAndValid();
    };

    // For shared offers only: automatically run the search once the package is
    // loaded, but only if all criteria getHotelDetailsAndNavigate requires are satisfied.
    // Depends on departureFrom because it is populated asynchronously on mount.
    useEffect(() => {
        if (!isBranched) return; // Important: only auto-search for the shared card.
        if (!isBranchSharedOffer) return;
        if (!canAutoSearch()) return;

        const offerId = offer?.hotelId;
        if (autoSearchedOfferId === offerId) return;

        autoSearchedOfferId = offerId;
        getHotelDetailsAndNavigate();
    }, [departureFrom]);

    return (
        <div className="showmore-favorite">
            <CalenderDateRangePicker
                show={showCalendar}
                triggerRef={calendarTriggerRef}
                onSelect={() => {
                    setShowCalendar(false);
                    setHasUserSelectedDates(true);
                }}
                onClose={() => setShowCalendar(false)}
                date={datesExistsAndValid() ? {
                    startDate: new Date(resolvedDepartureDate),
                    endDate: new Date(resolvedReturnDate)
                } : null}
            />
            <div className="row">
                <div className="col-lg-5">
                    <div className="dates-feilds">
                        <div className="check-in">
                            <div className="icon">
                                <FontAwesomeIcon icon={faCalendar} />
                            </div>
                            <div
                                ref={calendarTriggerRef}
                                className="text"
                                onClick={() => {
                                    setShowCalendar(!showCalendar);
                                    setShowTraveler(false);
                                }}
                            >
                                <h6 className="darkgray-text">{T("Filters:Check_In")}</h6>
                                <p className="no-margin">
                                    {!hasUserSelectedDates && datesExistsAndValid()
                                        ? moment(resolvedDepartureDate).format("MMM DD")
                                        : searchfilters.travelDate.startDate
                                            ? moment(searchfilters.travelDate.startDate).format("MMM DD")
                                            : T("Filters:Info_No_Date_Selected")}
                                </p>
                            </div>
                        </div>

                        <div className="check-out">
                            <div className="icon"></div>
                            <div
                                className="text"
                                onClick={() => {
                                    setShowCalendar(!showCalendar);
                                    setShowTraveler(false);
                                }}
                            >
                                <h6 className="darkgray-text">{T("Filters:Check_Out")}</h6>
                                <p className="no-margin">
                                    {!hasUserSelectedDates && datesExistsAndValid()
                                        ? moment(resolvedReturnDate).format("MMM DD")
                                        : searchfilters.travelDate.endDate
                                            ? moment(searchfilters.travelDate.endDate).format("MMM DD")
                                            : T("Filters:Info_No_Date_Selected")}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                    <div className="destinations">
                        <div className="icon">
                            <FontAwesomeIcon icon={faLocationDot} />
                        </div>
                        <div className="text">
                            <div
                                onClick={() =>
                                    setModals({
                                        ...modals,
                                        departure: !modals.departure,
                                    })
                                }
                                className="depart-from"
                            >
                                <h6 className="darkgray-text">
                                    {T("Filters:Departure_From")}
                                </h6>
                                <p className="no-margin">{getDepartureFromText()}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                    <div className="traveler">
                        <Dropdown
                            show={showTraveler}
                            onToggle={(show) => {
                                setShowTraveler(show);
                                setShowCalendar(false);
                            }}
                            align={{ sm: "start" } | { md: "end" } | { lg: "end" }}
                        >
                            <Dropdown.Toggle>
                                <div className="traveler-section">
                                    <div className="icon">
                                        <FontAwesomeIcon icon={faUser} />
                                    </div>
                                    <div className="text ">
                                        <h6 className="darkgray-text">{T("Common:Travelers")}</h6>
                                        <p className="no-margin">{tdetails}</p>
                                    </div>
                                </div>
                            </Dropdown.Toggle>
                            <Travelers setShowTraveler={setShowTraveler} />
                        </Dropdown>
                    </div>
                </div>
                <div className="col-lg-1 text-center">
                    <div
                        className="serach-action green-bg text-center"
                        onClick={getHotelDetailsAndNavigate}
                    >
                        <a className="white-text fs-16">{T("Buttons:Search")}</a>
                    </div>
                </div>
            </div>
            <DepartureFromModal
                show={modals.departure}
                onHide={() => setModals({ ...modals, departure: false })}
                onApplyButtonHandler={(values) => {
                    if (values?.length > 0) {
                        return setLocalDepartureFrom(
                            values.map((_departure) => _departure.code)
                        );
                    }
                    setLocalDepartureFrom([offer.departure]);
                }}
            />
        </div>
    );
};

FavoriteAccordionWebLink.propTypes = {
    offer: PropTypes.object.isRequired,
    isBranched: PropTypes.bool
}

export default FavoriteAccordionWebLink;
